import { ChangeDetectionStrategy, Component, Input } from '@angular/core';

@Component({
	selector: 'reach-menu',
	templateUrl: './menu.component.html',
	changeDetection: ChangeDetectionStrategy.OnPush,
	standalone: true,
	host: {
		class: 'fl fl-dir-c fl-ai-fs fl-jc-fs',
	},
})
export class ReachSmallMenuComponent {
	@Input() widthSmallMenu = false;
}
